import { useDefineAppLocation } from '@react-admin/ra-navigation';
import { match } from 'ts-pattern';

import { B2bInstrumentType, InstrumentType } from '@Common/types/instruments/instrument';

import { isBoExternal } from '@sh4res/bo-common/utils/env';

export function useSetInstrumentLocation(
  instrumentType: InstrumentType | B2bInstrumentType | 'stock' | undefined,
) {
  const path = match(instrumentType)
    .with('stock', 'stock-us', 'stock-uv-eu', () => 'instruments.stocks')
    .with('crypto', () => 'instruments.cryptos')
    .with('mutual-fund', () => 'instruments.mutual-funds')
    .otherwise(() => 'instruments');

  useDefineAppLocation(!isBoExternal() ? path : 'instruments');
}
